import { FC, useEffect } from 'react';
import { LifeCycles, registerApplication, start } from 'single-spa';
import { MenuMock } from '../mocks/MenuMock';
import AppShell from './Layout/AppShell';
import Emitter from './util/eventEmitter';

const RunRegister: FC<{}> = (props) => {
  
  useEffect(() => {
    MenuMock.items.forEach((_ , index) => { 
      registerApplication({
        name:_.spaName,
        app: (): Promise<LifeCycles> => (window as any).System.import(`@single-spa/${_.spaName}`),
        activeWhen:  [(location) => location.pathname === _.url] ,
        customProps: {
          name:_.nombre,
          emitter: Emitter,
        },
      });
    })

    start({
      urlRerouteOnly: true,
    });

  }, [])



  return (
    <>
      {
          /* El appshell , se encuentra contenido dentro del spin loader ,
           para asi mostrar este por sobre toda la app */
          <AppShell/>

      }
    </>
  );
}

export default RunRegister;
